"use client";

type Props = {
  error: Error & { digest?: string };
  reset: () => void;
};

export default function GlobalError({ reset }: Props) {
  return (
    <html lang="fa" dir="rtl">
      <body>
        <div className="min-h-screen bg-slate-950 text-slate-100 flex items-center justify-center p-6">
          <div className="w-full max-w-lg rounded-2xl border border-slate-700 bg-slate-900 p-6 text-right">
            <h2 className="text-lg font-bold">خطا در بارگذاری برنامه</h2>
            <p className="mt-2 text-sm text-slate-300">
              خطای موقت رخ داد. لطفاً صفحه را دوباره بارگذاری کنید.
            </p>
            <div className="mt-4 flex gap-2 justify-end">
              <button
                type="button"
                onClick={() => window.location.reload()}
                className="rounded-lg bg-cyan-600 px-4 py-2 text-sm font-semibold text-white hover:bg-cyan-500"
              >
                بارگذاری مجدد
              </button>
              <button
                type="button"
                onClick={reset}
                className="rounded-lg border border-slate-600 px-4 py-2 text-sm font-semibold text-slate-200 hover:bg-slate-800"
              >
                تلاش دوباره
              </button>
            </div>
          </div>
        </div>
      </body>
    </html>
  );
}

